var o = Object.prototype,
    r = o.toString;

function e(t) {
  return r.call(t);
}

var n = e;
export { n as _ };